import { useState } from 'react';

import { Box } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const LIFECYCLE_DEMO_FUNCTIONS = ['Engineering', 'People & Culture', 'Product', 'Sales'];

export const FunctionsMetaFilterDropdown = () => {
  const [selectedFunction, setSelectedFunction] = useState(LIFECYCLE_DEMO_FUNCTIONS[0]);

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            Function:
          </TextBodyMedium>
          <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
            <TextBodyMedium bold color="text.g1">
              {selectedFunction}
            </TextBodyMedium>
          </Box>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px' }}>
        <DropdownRadioGroup value={selectedFunction} onValueChange={(value) => setSelectedFunction(value)}>
          {LIFECYCLE_DEMO_FUNCTIONS.map((functionName) => (
            <DropdownRadioItem key={functionName} value={functionName}>
              {functionName}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};
